export default __webpack_public_path__ + "static/media/arrowRight.de7cbaec.svg";